import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

export default {
  title: 'Components/Link',
  component: 'a1-link',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Content Component - Anchor component to create a hyperlink to any content a URL can address.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-link';

const Template = (args: Components.A1Link): HTMLA1LinkElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Default: Story<Components.A1Link> = Template.bind({});
Default.args = {
  href: '#',
};

export const Primary: Story<Components.A1Link> = Template.bind({});
Primary.args = {
  ...Default.args,
  text: 'Primary Link',
  type: 'primary',
};

export const PrimaryDisabledLink: Story<Components.A1Link> = Template.bind({});
PrimaryDisabledLink.args = {
  text: 'Primary Disabled Link',
  type: 'primary',
  disabled: true,
};

export const Secondary: Story<Components.A1Link> = Template.bind({});
Secondary.args = {
  ...Default.args,
  text: 'Secondary Link',
  type: 'secondary',
};

export const SecondaryDisabledLink: Story<Components.A1Link> = Template.bind({});
SecondaryDisabledLink.args = {
  text: 'Secondary Disabled Link',
  type: 'secondary',
  disabled: true,
};

export const PrimaryInverse: Story<Components.A1Link> = Template.bind({});
PrimaryInverse.args = {
  ...Primary.args,
  inverse: true,
};
PrimaryInverse.parameters = {
  backgrounds: {
    default: 'Inverse',
  },
};

export const PrimaryInverseDisabled: Story<Components.A1Link> = Template.bind({});
PrimaryInverseDisabled.args = {
  text: 'Primary Link',
  type: 'primary',
  inverse: true,
  disabled: true,
};
PrimaryInverseDisabled.parameters = {
  backgrounds: {
    default: 'Inverse',
  },
};

export const SecondaryInverse: Story<Components.A1Link> = Template.bind({});
SecondaryInverse.args = {
  ...Secondary.args,
  inverse: true,
};
SecondaryInverse.parameters = {
  backgrounds: {
    default: 'Inverse',
  },
};

export const SecondaryInverseDisabled: Story<Components.A1Link> = Template.bind({});
SecondaryInverseDisabled.args = {
  text: 'Secondary Link',
  type: 'secondary',
  inverse: true,
  disabled: true,
};
SecondaryInverseDisabled.parameters = {
  backgrounds: {
    default: 'Inverse',
  },
};

export const IconBefore: Story<Components.A1Link> = Template.bind({});
IconBefore.args = {
  ...Default.args,
  text: 'Link Icon Before',
  iconPosition: 'before',
};

export const IconAfter: Story<Components.A1Link> = Template.bind({});
IconAfter.args = {
  ...Default.args,
  text: 'Link Icon After',
  iconPosition: 'after',
};

export const IconOnly: Story<Components.A1Link> = Template.bind({});
IconOnly.args = {
  ...Default.args,
  text: '',
};

export const AlternativeIcon: Story<Components.A1Link> = Template.bind({});
AlternativeIcon.args = {
  ...Default.args,
  text: '',
  iconName: 'check-circle',
};

export const Small: Story<Components.A1Link> = Template.bind({});
Small.args = {
  ...Default.args,
  text: 'Small Link',
  size: 's',
};
